import {
  Box,
  Card,
  Typography,
  Container,
  Divider,
  Button
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageTabTitle from 'src/components/PageTabTitle';

const MainContent = styled(Box)(
  () => `
    height: 100%;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
);

function Status404({token}) { 
  const navigate = useNavigate()
  useEffect(()=>{
    if(!token){
      localStorage.setItem('existingLocation', location?.pathname);
      navigate('/')
    }
  },[]) 

  return (
    <>
      {/* PageTitle component */}
      <PageTabTitle title="Status - 404" />
      {/* Main content block */}
      <MainContent>
        <Container maxWidth="md">
          <Container maxWidth="lg">
            <Card sx={{ textAlign: 'center', mt: 3, p: 4 }}>
              <Box textAlign="center">
                <img
                  alt="404"
                  height={180}
                  width={'100%'}
                  src="/static/images/status/404.svg"
                />
                <Typography variant="h2" sx={{ my: 2 }}>
                  The page you were looking for doesn't exist.
                </Typography>
              </Box>
              <Divider sx={{ my: 4 }} />
              <Button href="/" variant="outlined">
                Go to Login
              </Button>
            </Card>
          </Container>
        </Container>
      </MainContent>
    </>
  );
}

export default Status404;
